<template>
  <v-card flat>
    <v-divider />
    <v-card-title v-if="tasksLength" class="py-0 d-flex justify-center">
      <v-card-actions>
        <v-btn
          color="primary"
          text
          data-track="task.create-form.open"
          @click="showCreateTask = true"
        >
          <v-icon left>mdi-plus</v-icon>
          New Task
        </v-btn>
      </v-card-actions>
    </v-card-title>
    <v-card-text v-else class="text-center">
      <p>
        Create a task for yourself or a teammate. Keep track of all your
        to-dos for this record.
      </p>
      <v-btn class="primary" data-track="task.create-form.open" @click="showCreateTask = true">Create Task</v-btn>
    </v-card-text>
    <CreateTaskForm
      v-model="showCreateTask"
      :associated-records="associatedRecords"
      :collection-type="collectionType"
      @submit="onSubmit"
    />
  </v-card>
</template>

<script lang="ts">
import mixins from 'vue-typed-mixins';

import { DialogMixin } from '@/bundles/Dialogs/mixins/DialogMixin';

import CreateTaskForm from '@/bundles/Tasks/components/CreateTaskForm.vue';

interface IRecordTaskCard {
  showCreateTask: boolean;
}

export default mixins(DialogMixin).extend({
  name: 'RecordTaskCard',

  components: { CreateTaskForm },

  props: {
    tasksLength: {
      type: Number,
      default: 0
    },
    associatedRecords: {
      type: Array,
      default: () => []
    },
    collectionType: {
      type: String,
      default: '',
    }
  },

  data: (): IRecordTaskCard => ({
    showCreateTask: false
  }),

  methods: {
    onSubmit: function () {
      this.$eventBus.$emit('fetch:tasks');
    }
  }
})
</script>
